<template>
  <div class="teachers-section">
    <div class="section-left">
      <!-- 通知公告 -->
      <div class="notice-block">
        <div class="section-header">
          <p class="section-title">党群园地</p>
          <a @click="goNavMore(10)" class="more-link">MORE+</a>
        </div>
        <div class="notice-list">
          <div class="notice-item" v-for="(notice, index) in firstList.slice(0,6)" :key="index" @click="goDetail(notice)">
            <span class="notice-bullet">■</span>
            <span class="notice-text">{{ notice.title }}</span>
            <span class="notice-date">{{ notice.date }}</span>
          </div>
        </div>
      </div>

      <!-- 通知公告 -->
      <div class="notice-block section-center">
        <div class="section-header">
          <p class="section-title">百年校庆</p>
          <a @click="goNavMore(9)" class="more-link">MORE+</a>
        </div>
        <div class="notice-list">
          <div class="notice-item" v-for="(notice, index) in secondList.slice(0,6)" :key="index" @click="goDetail(notice)">
            <span class="notice-bullet">■</span>
            <span class="notice-text">{{ notice.title }}</span>
            <span class="notice-date">{{ notice.date }}</span>
          </div>
        </div>
      </div>
     </div>

    <div class="section-right">
     <!-- 校园视频 -->
      <div class="notice-block">
        <div class="section-header">
          <p class="section-title">校园视频</p>
          <a class="more-link" @click="goCategoryMore(1304)">MORE+</a>
        </div>
        <div class="video-list"  @click="goVideoSpecial">
          <div class="tu"><img :src="videoObj.coverImage" alt=""></div>
          <p class="title">{{ videoObj.title }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { homeApi,subApi } from '@/api/index'
export default {
  name: 'TeachersSection',
  data() {
    return {
      
      videoObj:{},
      firstList:[],
      secondList:[],
      loading:false

    }
  },
  mounted(){
    this.getvideo();
    this.getFirstList();
    this.getSecondList();
  },
  methods:{
    //获取党群园地数据
    async getFirstList(){
    
      this.loading = true;

      try {
        let params = {
          categoryId:10,
          count:6
        }
        
        const response = await subApi.getNavList(params)
      
        if (response && response.code === 0) {
          // 清空之前的数据
          
          
          let data = response.data.subList;
           data.forEach(sub =>{
             sub.items.forEach(items=>{
           
                this.firstList.push({
                  title:items.title,
                  date:items.datetime,
                  id:items.id
                
                })
             })
            })
          
         
        } else {
          
          // 设置默认数据
         this.firstList = [];
        }
      } catch (error) {
        
        // 设置默认数据
       this.firstList = [];
      } finally {
        // 隐藏加载状态
        this.loading = false;
      }
    },
     //获取b百年校庆数据
    async getSecondList(){
    
      this.loading = true;

      try {
        let params = {
          categoryId:9,
          count:6
        }
        
        const response = await subApi.getNavList(params)
      
        if (response && response.code === 0) {
         
          let data = response.data.subList;
           data.forEach(sub =>{
             sub.items.forEach(items=>{
           
                this.secondList.push({
                  title:items.title,
                  date:items.datetime,
                  id:items.id
                
                })
             })
            })
          
         
        } else {
          
          // 设置默认数据
         this.secondList = [];
        }
      } catch (error) {
        
        // 设置默认数据
       this.secondList = [];
      } finally {
        // 隐藏加载状态
        this.loading = false;
      }
    },
     //获取视频列表数据
    async getvideo(){
      try {
        let params = {
          pageNo:1,
          pageSize:1
        }
        
        const response = await homeApi.getvideo(params)
        console.log('response',response)
        if (response &&  response.code === 0) {         
            this.videoObj = response.data.list[0];         
        } else {
          console.error('获取视频列表数据失败:', response)
        }
      } catch (error) {
        console.error('获取视频列表数据异常:', error)
      
      }
    },

    goVideoSpecial(){
      this.$router.push({
        path:'/videoSpecial',
        query:{
          id:this.videoObj.id
        }
      })
    },
    goNavMore(id){
      this.$router.push({
        path:'/category',
        query:{
          id:id
        }
      })
    },
     goDetail(item){   
      this.$router.push({
        path:'/article',
        query:{
          id:item.id
        }
      })
    },
    goCategoryMore(navSubId){
       let data =JSON.parse(sessionStorage.getItem('navList')) ;
        console.log('data',data)
        let query = {
            categoryId: '',
            sectionId:navSubId,
            categoryTitle: '',
            sectionTitle: ''
        }
     
        data.forEach(item => {
          //console.log(item)
          if(item.children && item.children.length > 0){
            const matchedChild = item.children.find(child => child.id == navSubId);
            console.log('matchedChild',matchedChild)
            if(matchedChild) {
           
              query.categoryId = item.id;
              query.categoryTitle = item.title;
              query.sectionTitle = matchedChild.title
            }
          }
        });

     
        this.$router.push({
          path: '/categoryMore',
          query:query
        })
    }
  }
}
</script>

<style scoped>
.teachers-section {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 30px;
  margin-bottom: 30px;
}

.section-left{
  width: 800px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  .notice-block{
    width: 385px;
  }
}
.section-right{
  width:320px ;
  cursor: pointer;
}
.notice-block {
  
  background: #fff;
  height: 305px;
  overflow: hidden;
   box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  background: #fff;
  border-radius: 8px;
  .section-header{
     border-top:1px solid #3591f9;
     display: flex;
     position: relative;
     .section-title{
        background: #3591f9;
        color: #fff;
        font-size: 16px;
        margin-right: 6px;
        padding: 12px 16px;
        border-bottom-left-radius: 4px;
        border-bottom-right-radius: 4px;
       
     }

  }

  

  

  .more-link {
    color: #333;
    text-decoration: none;
    font-size:12px;
    padding: 12px 16px;
    position: absolute;
    right: 0;
    top: 0;
    cursor: pointer;
  }
}


.section-center{
    .section-header{
       border-top:1px solid #1dc2b7;
        .section-title{
          background: #1dc2b7;
        }
    }
}  

.section-right{
    .section-header{
       border-top:1px solid #f1c25f;
        .section-title{
          background: #f1c25f;
        }
    }
} 

.video-list{
  display: block;
  position: relative;
  padding:30px 10px;
  .tu{
    width: 300px;
    height: 200px;
    border-radius: 10px;
    overflow: hidden;
    img{
      display: block;
      width: 100%;
      height: 100%;
    }
  }
  .title{
     width: 300px;
    height: 30px;
    line-height: 30px;
    background: rgba(0,0,0,0.6);
    color: #fff;
    padding: 0 4px;
     overflow: hidden;
     text-overflow: ellipsis;
    white-space: nowrap;
    position: absolute;
    left:10px;
    bottom: 30px;
  }
}

/* 通知列表样式 */
.notice-list {
  padding: 20px;
}

.notice-item {
  display: flex;
  align-items: center;
  padding: 8px 0;
  border-bottom: 1px solid #f0f0f0;
  transition: all 0.3s ease;
  cursor: pointer;
}

.notice-item:hover {
  background-color: #f8f9fa;
  transform: translateX(5px);
}

.notice-item:hover .notice-text {
  color: #1e3c72;
}

.notice-item:hover .notice-bullet {
  color: #dc3545;
}

.notice-item:last-child {
  border-bottom: none;
}

/* 蓝色方块标记 */
.notice-bullet {
  color: #1e3c72;
  margin-right: 8px;
  font-size: 12px;
  flex-shrink: 0;
}

/* 标题文字 */
.notice-text {
  flex: 1;
  color: #333;
  font-size: 14px;
  line-height: 1.4;
  margin-right: 10px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

/* 日期样式 */
.notice-date {
  color: #666;
  font-size: 12px;
  white-space: nowrap;
  flex-shrink: 0;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .teachers-section {
    grid-template-columns: 1fr;
    gap: 20px;
  }
  
  .section-left {
    width: 100%;
    flex-direction: column;
    gap: 20px;
  }
  
  .section-left .notice-block {
    width: 100%;
  }
  
  .section-right {
    width: 100%;
  }
  
  .notice-text {
    font-size: 13px;
  }
  
  .notice-date {
    font-size: 11px;
  }
  
  .notice-bullet {
    font-size: 11px;
  }
}

@media (max-width: 480px) {
  .notice-list {
    padding: 15px;
  }
  
  .notice-text {
    font-size: 12px;
  }
  
  .notice-date {
    font-size: 10px;
  }
  
  .notice-bullet {
    font-size: 10px;
    margin-right: 6px;
  }
}





</style>

